import React, { useState } from 'react'
import './blogs.css'
import ArticlePreview from './artical-preview.js'
import SectionExpand from '../../../components/section-expand'

const collapsedSlugs = [
  'halfway-through-graduate',
  'Six-past-TwentyTwo',
  '3-months-farewell-3-years-final',
]
const archiveStartSlug = 'farewell-2020'

const Blogs = ({ data }) => {
  const [expanded, setExpanded] = useState(false)
  const archiveStart = data.findIndex(
    ({ node }) => node.slug === archiveStartSlug
  )
  const isCollapsed = (node, index) =>
    collapsedSlugs.includes(node.slug) ||
    (archiveStart !== -1 && index >= archiveStart)
  const hasMore = data.some(({ node }, index) => isCollapsed(node, index))

  return (
    <div className={`BlogsGroup${expanded ? ' BlogsGroupExpanded' : ''}`}>
      <ul className="article-list" id="study-articles">
        {data.map(({ node }, index) => (
          <li
            key={node.slug}
            className={`non-full-view${
              isCollapsed(node, index) ? ' BlogEntryExtra' : ''
            }`}
          >
            <ArticlePreview article={node} />
          </li>
        ))}
      </ul>
      {hasMore && (
        <SectionExpand
          className="BlogsToggle"
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
          controls="study-articles"
          label="济济一堂"
        />
      )}
    </div>
  )
}

export default React.memo(Blogs)
